<template>
  <div>

    <div class="stockli__form-intro bkgr-steep">
      <div class="stockli__form-intro--text black-trans-bkgr ">
        <div class="h4 white-text mb-0">Customize Your Indicator Setting</div>
      </div>
    </div>
    <div class="stockli__form-container">
      <div class="progress-indicator">
        <router-link to="/info">
          <div class="step-indicator active">Contact Info</div>
        </router-link>
        <div class="step-line active"></div>
        <router-link to="/calculator">
          <div class="step-indicator active">Release Preference</div>
        </router-link>
        <div class="step-line active"></div>
        <div class="step-indicator active">Your Setting</div>
        <div class="step-line"></div>
        <div class="step-indicator">Submit</div>
      </div>
      
      <div>
        
        <p>
          Your normal indicator settings comply with ASTM standards.
          Although these guidelines may be inappropriate for some types
          of competitive skiing or competition training, they are believed
          to provide an effective compromise between the release and
          retention needs of most recreational skiers.</p>
          <p>Adhering to these guidelines may help to reduce the risk of
          injuries resulting from improper indicator setting selection.
          However, skiing involves inherent risks. Injury can result from
          simply falling down, impact with an object, or from many other
          actions. Many injuries are unrelated to the function of the release
          system. Furthermore, even a properly adjusted ski/binding/boot
          system cannot protect the skier in all situations.</p>
          <p>Difficulties with release or retention may be unrelated to indicator
          settings. They can result from your skiing style, the incompatibility
          of your boots and bindings, wear, damage, or contamination of the
          release system. Be sure to describe your circumstances to the
          shop technician and to authorize recommended inspections and
          repairs before proceeding.</p>
          <p>If you have been dissatisfied with the indicator settings that
          result from your normal release preference , you may wish
          to consider changing your release preference, designating
          skier release preferences that are different for twist and
          forward lean, or request discretionary indicator settings that
          are higher or lower than the normal range.</p>
          <p>Lower settings correspond to an increase in the risk of
          inadvertent binding release in order to gain increased
          releasability in a fall.</p>
          <p>Higher settings correspond to a decrease in releasability in
          a fall in order to gain a decreased risk of inadvertent binding
          release.</p>
          <p>Although the Stockli representative may help you to record your
          choice below, the final decision on your indicator settings is yours, the skiers.</p>
        <h4 class="py-5">I assume these additional risks and will select my own Indicator Setting.</h4>
        <v-form ref="form" @submit.prevent="Submit">
          <v-row dense>
            <v-col cols="12">
              <v-text-field v-model="indicator" label="Indicator Setting" type="number" min="0" max="20" step="0.25" :rules="[ruleRequired]" />
            </v-col>
            <v-col cols="12">
              <v-text-field v-model="initials" label="Initials" type="text" :rules="[ruleRequired]" />
            </v-col>
          </v-row>
          <v-btn type="submit">Submit</v-btn>
        </v-form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CustomIndicator",
  components: {
  },
  data: () => ({
    indicator: undefined,
    initials: undefined,

    ruleRequired: v => !!v || "This field is required",
  }),
  computed: {
  },
  mounted() {
  },
  methods: {
    Submit() {
      if (!this.$refs.form.validate()) return;

      // Update the stored indicator value
      this.$store.commit("updateField", { path: "skierInfo.Indicator_Setting", value: "Custom (" + this.indicator + ")" });
      this.$router.push({ name: "CalculatorResult" });
    },
  },
}
</script>
<style scoped lang="scss">
</style>
